import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Add from '../../../../modal/Settings/HR_Managment/Department/AddDepartment';
import Edit from '../../../../modal/Settings/HR_Managment/Department/EditDepartment';
import EditDepartment from '../../../../modal/Settings/HR_Managment/Department/EditDepartment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
 
 
const Department = () => { 
    const tableRef = useRef(null);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [departments, setDepartments] = useState([]);
    const [open, setOpen] = useState(false); // Modal visibility state
    const [modalType, setModalType] = useState("");
    const [editModalShow, setEditModalShow] = useState(false);
    const [currentItemId, setCurrentDepartmentId] = useState(null);
    const [hasFetched, setHasFetched] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [TotalCount, setTotalCount] = useState('');

    const handleModalToggle = () => {
        setModalType("Add");  // Set the modal type to "Add"
        setOpen(true);  // Toggle the modal visibility
    };
    const handleModalToggle_Edit = () => {
        setModalType("Edit");  // Set the modal type to "Add"
        setOpen(true);
    };

    const handleModalDepartment_Edit = (departmentId) => { 
        setEditModalShow(true);
        setCurrentDepartmentId(departmentId);
    };

        const DeleteModal = (departmentId, departmentName) => {
            swal.fire({
                html: `
                    <div class="alert alert-danger px-2 py-2" role="alert">
                        <strong>OOPS! </strong> You're about to delete this Department.
                    </div>
                    <p class="text-center"><b>${departmentName}</b></p>
                `,
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'Cancel',
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn btn-sm btn-secondary',
                    confirmButton: 'btn btn-sm btn-danger',
                },
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(`${baseURL}/department/${departmentId}`)
                        .then(() => {
                            // swal.fire({
                            //     title: 'Department Deleted!',
                            //     text: `${departmentName}`,
                            //     icon: 'success',
                            //     confirmButtonText: 'OK',
                            //     customClass: {
                            //         confirmButton: 'btn btn-sm btn-primary',
                            //     }
                            // });
                            
                            fetchDepartments(); // Refresh table data
                            toast.success("Department Deleted successfully!");
                        })
                        .catch(error => {
                            console.error("Delete failed:", error);
                            toast.error("Department Delition Failed!");
                            // swal.fire("Error", "Failed to delete the department.", "error");
                        });
                } 
                // else {
                //     swal.fire({
                //         title: 'Delete Cancelled',
                //         text: `${departmentName}`,
                //         icon: 'warning',
                //         confirmButtonText: 'OK',
                //         customClass: {
                //             confirmButton: 'btn btn-sm btn-primary',
                //         }
                //     });
                // }
            });
        };
        
     
        
        // const fetchDepartments = () => {
        //     axios.get('http://192.168.3.105:1711/api/department')
        //         .then(response => {
        //             const data = response.data;
        //             if (Array.isArray(data)) {
        //                 setDepartments(data);
        //             } else if (Array.isArray(data?.data)) {
        //                 setDepartments(data.data);
        //             } else {
        //                 console.warn("Unexpected response format:", data);
        //                 setDepartments([]);
        //             }
        //         })
        //         .catch(error => {
        //             console.error("Error fetching departments:", error);
        //             setDepartments([]);
        //         });
        // };
        
        // useEffect(() => {
        //     fetchDepartments();
        // }, []);

        const fetchDepartments = () => {
            const params = {
                page,
                per_page: perPage,
                search: searchTerm,
            };

            axios
                .get(`${baseURL}/department/list`, { params })
                .then(response => {
                    setDepartments(response.data.data.data);
                    setTotalPages(response.data.data.last_page);
                    setTotalCount(response.data.data.total);
                    setHasFetched(true);
                })
                .catch(error => {
                    console.error("Error fetching departments:", error);
                    setDepartments([]);
                    setTotalPages(1);
                    setTotalCount(0);
                    setHasFetched(true);
                });
        };

        useEffect(() => {
            fetchDepartments();
        }, [page, perPage, searchTerm]);
        
        // useEffect(() => {
        //     let dataTableInstance;
        
        //     if (departments.length > 0 && tableRef.current) {
        //         if ($.fn.DataTable.isDataTable(tableRef.current)) {
        //             $(tableRef.current).DataTable().clear().destroy(); // ✅ Safe cleanup
        //         }
        
        //         dataTableInstance = $(tableRef.current).DataTable({
        //             responsive: true,
        //             ordering: false,
        //             destroy: true,
        //             language: {
        //                 lengthMenu: "Show _MENU_",
        //             },
        //             dom:
        //                 "<'row'" +
        //                 "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
        //                 "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
        //                 ">" +
        //                 "<'table-responsive'tr>" +
        //                 "<'row'" +
        //                 "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
        //                 "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
        //                 ">"
        //         });
        //     }
        
        //     return () => {
        //         if ($.fn.DataTable.isDataTable(tableRef.current)) {
        //             $(tableRef.current).DataTable().destroy(); // ✅ Cleanup on unmount
        //         }
        //     };
        // }, [departments]);

        useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "destroy": true,
                        "paging": false,
                        "searching": false,
                        "info": false,
                        "responsive": true,
                        pageLength: 25,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [departments]);
        
        const handleStatusChange = (departmentId, currentStatus) => {
            const newStatus = currentStatus === 0 ? 1 : 0;
        
            axios.put(`${baseURL}/department/status/${departmentId}`, { status: newStatus })
                .then(() => {
                    fetchDepartments();
                    toast.success("Status Updated successfully!");
                })
                .catch(error => {
                    console.error("Error updating status:", error);
                    toast.error("Status Updation Failled!");
                });
        };
        
    
 
    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Department</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item"><Link to='/settings'>Settings</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">HR Management</li>
                </ol>
                </div>
                <Button
                    className="btn btn-primary btn-sm"
                    onClick={handleModalToggle}
                >
                    <span className="me-2">
                        <i className="fa-solid fa-plus fs-8"></i>
                    </span>
                    <span>Add Department</span>
                </Button>
                {open && modalType === "Add" && (
                    <Add show={open} onClose={() => setOpen(false)} refresh={fetchDepartments}/>
                )}
                {open && modalType === "Edit" && (
                    <Edit show={open} onClose={() => setOpen(false)} refresh={fetchDepartments}/>
                )}
            </div>
            <div className="table-container">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{  fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                    <div>
                        <input
                            type="text"
                            style={{  fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                </div>
                <table ref={tableRef} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-50px text-start'>S.No</th>
                            <th className='min-w-150px'>Department</th>
                            <th className='min-w-300px'>Description</th>
                            <th className='min-w-100px'>Status</th>
                            {/* <th className='min-w-100px'>Actions</th> */}
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                        {departments.length === 0 && hasFetched ? (
                            <tr>
                                <td colSpan="7" className="text-center text-muted py-2">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            <>
                    {departments.map((departments, idx) => (
                        <tr  key={departments.sno}>
                            <td className='text-start'>
                                <label className='text-black font-w400 fs-7'>{idx + 1}</label>
                            </td>
                            <td>
                                <label className='text-black font-w400 fs-7'>{departments.department_name}</label>
                            </td>
                            <td>
                                <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{departments.description || "No description available."}</span></Tooltip>} >
                                    <div className='text-truncate mw-400px text-black font-w400 fs-7'>{departments.description || "No description available."}</div>
                                </OverlayTrigger>
                            </td>
                            <td> 
                                <div className="form-check form-switch d-flex align-items-center mb-3">
                                        <input
                                            className="form-check-input me-2"
                                            type="checkbox"
                                            role="switch"
                                            checked={departments.status == 0}
                                            onChange={() => handleStatusChange(departments.sno, departments.status)}
                                        />
                                 </div>
                            </td> 
                             {/* <td>
                                <span className="text-end">
                                    <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>}>
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalDepartment_Edit(departments.sno)}>
                                            <i className="fa-solid fa-pen-to-square fs-6"></i>
                                        </Button>
                                    </OverlayTrigger>
                                    <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Delete</span></Tooltip>}>
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => DeleteModal(departments.sno, departments.department_name)}>
                                            <i className="fa-solid fa-trash-can fs-6 mt-1"></i>
                                        </Button>
                                    </OverlayTrigger>
                                </span>
                            </td> */}
                        </tr>
                       ))}
                         </>
                        )}
                    </tbody>
                </table>
                <div className="d-flex justify-content-between align-items-center mt-3">
                    {/* Bottom left: Showing x to y of z entries */}
                    <div>
                        {departments.length > 0 ? (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + departments.length} of {TotalCount} entries
                            </span>
                        ):(
                            <span className="text-muted">
                                Showing 0 to 0 of 0 entries
                            </span>
                        )}
                    </div>

                    {/* Bottom right: Pagination */}
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                            </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>

                </div>
                 <EditDepartment
                    show={editModalShow}
                    onClose={() => setEditModalShow(false)}
                    departmentId={currentItemId}
                    onUpdated={fetchDepartments}
                />
            </div>
        </>
    )


}
export default Department;